$(document).ready(function () {
    $(".select2-city").each(function () {
        let current = $(this);
        current.css('width', '100% !important');
        current.on('select2:select', function (e) {
            let data = e.params.data;
            if($('[name="' + current.attr("name") + '-label"]').length){
                $('[name="' + current.attr("name") + '-label"]').val(data.text);
            }
        });
        current.select2({
            language: $("html").attr("lang"),
            dropdownCssClass: "select2-" + current.attr("name"),
            ajax: {
                url: current.data('url'),
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        needle: params.term, // search term
                    };
                },
                processResults: function (data) {
                    let selectobj = $.map(data, function (v) {
                        return {
                            'text': v[current.data('text_field')],
                            'id': v[current.data('id_field')] ? v[current.data('id_field')] : v['id'],
                            'province_name': v.province_name,
                            'region_name': v.region_name,
                        }
                    });
                    return { results: selectobj };
                },
                cache: true,
                error: function (err) {

                }
            },
            placeholder: current.data('placeholder'),
            minimumInputLength: 2,
            allowClear: true,
            templateSelection: function (data, container) {
                $(data.element).attr('data-province_name', data.province_name);
                $(data.element).attr('data-region_name', data.region_name);
                // Add custom attributes to the <option> tag for the selected option
                return data.text;
            },
        });
        if($('[name="' + current.attr("name") + '-label"]').length){
            $('[name="' + current.attr("name") + '-label"]').val(current.text());
        }
    });

    $(".select2-city").on('change', function () {
        let selected = $(this).find(':selected');
        let province = $(selected).data('province_name');
        let region = $(selected).data('region_name');
        let provinceSelectID = $(this).data('autofill_province');
        let regionSelectID = $(this).data('autofill_region');
        let provinceSelect = $('#' + provinceSelectID);
        let regionSelect = $('#' + regionSelectID);


        if ($(provinceSelect).find('option[value="' + province + '"]').length) {
            $(provinceSelect).val(province).trigger('change');
        } else {
            let newOption = new Option(province, province, true, true);
            $(provinceSelect).append(newOption).trigger('change');
        }

        if ($(regionSelect).find('option[value="' + province + '"]').length) {
            $(regionSelect).val(province).trigger('change');
        } else {
            let newOption = new Option(region, region, true, true);
            $(regionSelect).append(newOption).trigger('change');
        }
    })
});



// WEBPACK FOOTER //
// ./resources/js/app/_global.js